import { DateTime } from "luxon";
import { DateTimeRange } from "./date-extensions";

export function stringToDateTime(
  text: string,
  date?: DateTime,
  timezone?: string,
  endTime = false,
): DateTime | null {
  date = date || DateTime.now();
  const parts = text.split(":");
  if (parts.length !== 2) return null;

  const hour = parseInt(parts[0], 10);
  const minute = parseInt(parts[1], 10);

  if (isNaN(hour) || isNaN(minute)) return null;

  if (endTime && hour === 0 && minute === 0) {
    return DateTime.fromObject(
      {
        year: date.year,
        month: date.month,
        day: date.day + 1,
        hour: 0,
        minute: 0,
      },
      { zone: timezone ?? date?.zoneName ?? "UTC" },
    );
  }

  const dateTime = DateTime.fromObject(
    {
      year: date.year,
      month: date.month,
      day: date.day,
      hour: hour,
      minute: minute,
    },
    { zone: timezone ?? date?.zoneName ?? "UTC" },
  );

  return dateTime;
}

export function stringToDateTimeRange(
  text: string,
  date?: DateTime,
  timezone?: string,
): DateTimeRange | null {
  const times = text.split("-");

  if (times.length !== 2) return null;

  const startTime = stringToDateTime(times[0], date, timezone);
  const endTime = stringToDateTime(times[1], date, timezone, true);

  if (!startTime || !endTime) return null;

  return { start: startTime, end: endTime };
}

export function sanitizeString(text: string): string {
  return text
    .toLowerCase()
    .replace(/ /g, "-")
    .replace(/[^a-z0-9-]/g, "");
}
